import api from '~api'

export const url = `/address-name`

export async function getRegions () {
  const {
    data
  } = await api.get(`${url}`)

  return (data.data)
}

export async function getSubregionByRegionId (id) {
  const {
    data
  } = await api.get(`${url}/?id=${id}`)

  return (data.data)
}
